import { render, staticRenderFns } from "./IconFileDefault.vue?vue&type=template&id=8e722406"
import script from "./IconFileDefault.vue?vue&type=script&lang=js"
export * from "./IconFileDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports